"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clickEvent = void 0;
const utils_1 = require("../utils");
const clickEvent = ({ trackingService, componentNameWithSpaces, componentNameWithDashes, defaultComponentAdditions, }) => (customEvent = {}) => {
    var _a, _b, _c;
    if (!trackingService) {
        return;
    }
    const eventAction = ((_b = (_a = customEvent.event) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.targetURL) &&
        trackingService.evaluateLinkType((_c = customEvent.event) === null || _c === void 0 ? void 0 : _c.attributes.targetURL);
    const defaultClickEvent = {
        event: {
            attributes: {
                componentName: componentNameWithDashes,
                elementName: '',
                label: '',
                clickID: '',
                pos: '',
                targetURL: '',
                value: '',
                relatedElements: [],
            },
            eventInfo: {
                eventAction: eventAction || 'content', // Update EventAction using trackingService.evaluateLinkType
                eventName: `${componentNameWithSpaces} - click on cta`,
            },
        },
        componentUpdate: defaultComponentAdditions,
    };
    const mergedEvent = (0, utils_1.mergeHandler)(defaultClickEvent, customEvent, {
        merge: 'deep',
        arrayBehavior: 'replace',
    });
    trackingService.track(mergedEvent);
};
exports.clickEvent = clickEvent;
//# sourceMappingURL=send-click.js.map